import React, { useState } from 'react';
import { observer } from 'mobx-react';
import Helmet from 'react-helmet';
import { Image } from 'semantic-ui-react';

import AuthFormComponent from '#/shared/components/AuthForm';
import { ErrorBoundary } from '#/shared/components/utils/ErrorBoundary';
import { AuthForm } from '#/shared/forms/auth';
import { UserForm } from '#/shared/forms/user';
import { OTPForm } from '#/shared/forms/otp';

const Auth = observer(() => {
  const [authForm] = useState(new AuthForm());
  const [userForm] = useState(new UserForm());
  const [otpForm] = useState(new OTPForm());

  return (
    <div className="pt5 mh5 tc">
      <Helmet title="Welcome to Shiftsmart" />
      <Image centered={true} size="large" src="/static/img/logoOnWhite.png" />
      <h3>Please login to your Employer account to get started</h3>
      <ErrorBoundary title="Auth.AuthForm">
        <AuthFormComponent
          forms={{
            login: authForm,
            otp: otpForm,
            register: userForm,
          }}
        />
      </ErrorBoundary>
    </div>
  );
});

Auth.displayName = 'Auth';

export default Auth;
